import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { LabelSm } from "@circle-react-shared/uikit/Typography/components/Label/LabelSm";
import type { ChatButtonProps } from "../../types/ChatButtonProps";
import { UserGroupAvatar } from "./UserGroupAvatar";

export const ChatButton = ({
  label,
  sublabel,
  event,
  selected,
  setSelected,
  preferred = false,
  onClick,
  disabled = false,
}: ChatButtonProps) => {
  const isSelected = selected === event;
  const isNoSelection = selected === null;
  const isClickable = isNoSelection && !disabled;

  const handleOnClick = () => {
    if (isNoSelection) {
      setSelected(event);
      onClick();
    }
  };

  const variantClasses =
    preferred &&
    isNoSelection &&
    "bg-[#2B2E33] dark:bg-white dark:text-primary text-black dark:hover:bg-[#F7F9FA]";

  const baseClasses =
    "h-[34px] rounded-xl border border-primary px-4 py-2 text-sm font-medium flex gap-2 items-center justify-center";

  const interactionClasses = classNames({
    "hover:bg-secondary cursor-pointer": isClickable && !preferred,
    "hover:bg-[#42464D] cursor-pointer": isClickable && preferred,
    "shadow-[0px_0px_0px_3px_rgba(113,118,128,0.30)] border-[#717680] dark:border-[#D2D7DB]":
      isSelected,
    "cursor-not-allowed": !isClickable,
    "w-full": Boolean(sublabel),
  });

  const labelColor =
    !isNoSelection && !isSelected // Grey out the non-selected button label
      ? "text-disabled"
      : preferred && isNoSelection
        ? "text-white dark:text-gray-900"
        : "text-gray-900 dark:text-white";

  return (
    <button
      disabled={disabled}
      type="button"
      className={classNames(baseClasses, variantClasses, interactionClasses)}
      onClick={handleOnClick}
    >
      {preferred && <UserGroupAvatar count={3} size="5" />}

      <LabelSm weight="medium" color={labelColor}>
        {label}
        {sublabel && ` • ${sublabel}`}
      </LabelSm>
    </button>
  );
};
